// extracted by mini-css-extract-plugin
export var brand = "_69-8";
export var compact = "_69-5";
export var extraSmall = "_69-6";
export var icon = "_69-0";
export var large = "_69-3";
export var light = "_69-1";
export var medium = "_69-4";
export var outline = "_69-a";
export var primaryDark = "_69-9";
export var primaryLight = "_69-7";
export var primaryModern = "_69-b";
export var success = "_69-2";